import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { firebaseConfig } from './config';

// Initialize Firebase (singleton)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);

// Set persistence and export promise so consumers can await if needed
export const authReady = setPersistence(auth, browserLocalPersistence).catch(() => {
  // Fallback silently — in-memory persistence will be used
});

export const db = getFirestore(app);
export const storage = getStorage(app);
